<template>
  <div id="app">
    <SkipNav />
    <OfficialSite />
    <Header />
    <transition mode="out-in"
                enter-active-class="animate__animated animate__fadeIn"
                leave-active-class="animate__animated animate__fadeOut">
      <main id="mainContent">
        <router-view />
      </main>
    </transition>
    <Footer />

    <!-- full screen spinner -->
    <ModalSpinner />
  </div>
</template>

<script>
import SkipNav from '@/components/SkipNav'
import OfficialSite from '@/components/OfficialSite'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import ModalSpinner from '@/components/appModal/ModalSpinner'

export default {
  components: {
    SkipNav,
    OfficialSite,
    Header,
    Footer,
    ModalSpinner,
  },
}
</script>

<style lang="scss">
@import "~@ridmv/web-themes";
@import "~animate.css";
.animate__animated.animate__fadeOut {
  --animate-duration: .35s;
}
</style>
